export { onRenderClient };

import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import type { OnRenderClientAsync } from "vike/types";
import { routes } from "../routing/AppRouter";
import { StandaloneErrorBoundary } from "../StandaloneErrorBoundary";
import { AppTrackingProvider } from "../tracking/Tracking";

const onRenderClient: OnRenderClientAsync = async (pageContext) => {
  import("@sentry/browser").then((Sentry) => {
    Sentry.init({
      dsn: "https://39ff004f0e38423985f39258a6782694@o208856.ingest.sentry.io/5384083",
      enabled: document.location.hostname === "skademelding.naf.no",
      environment: document.location.hostname,
      release: import.meta.env.PUBLIC_ENV__COMMIT_ID,
      debug: false,
      integrations: [
        Sentry.dedupeIntegration,
        Sentry.browserTracingIntegration(),
      ],
    });
  });

  const container = document.getElementById("root");
  if (!container) throw new Error("No root found");

  const router = createBrowserRouter(routes, {
    future: {
      v7_partialHydration: true,
    },
  });

  const page = (
    <StandaloneErrorBoundary>
      <AppTrackingProvider>
        <RouterProvider
          router={router}
          future={{
            v7_startTransition: true,
          }}
        />
      </AppTrackingProvider>
    </StandaloneErrorBoundary>
  );

  let root: ReactDOM.Root;
  if (pageContext.isHydration && pageContext.config.hydrate) {
    const title = pageContext.config.documentProps?.title;
    if (title) {
      document.title = title;
    }
    root = ReactDOM.hydrateRoot(container, page, {
      onRecoverableError(err, info) {
        import("@sentry/browser").then((Sentry) =>
          Sentry.captureException(err, { extra: { info } }),
        );
        console.error({ err, info });
      },
    });
  } else {
    root = ReactDOM.createRoot(container);
    root.render(page);
  }
};
